<template>
	<div class="hello">
		<h1>Hello, potential future employer!</h1>
		<p>
			You have questions, I've got answers
		</p>
		<h3>APIs, RESTful APIS, JSON</h3>
		<p>I work with these daily, writing both calls and responses, building front-end architecture based on existing api responses as well as determining formatting of new responses. (This REALLY seems to be top of everyone's list, so I wanted to clear it up immediately).</p>
		<h3>Feelings on stack</h3>
		<p>Emphatically stack agnostic! Like new jobs, the more important thing is being able to learn and adapt. Even if you know every aspect of a library or framework, you still need to learn/help inform how your team implements them. Paying attention and being mindful of chosen conventions is key.</p>
		<h3>Where do I see myself in 5 years?</h3>
		<p>lol. Ok but really, I'll be working with a diverse team of driven people. I won't trade coding for managing, but I do intend to lead.</p>
		<h3>How do you keep informed about the coding world?</h3>
		<p>Twitter. I follow inspiring people building amazing things.</p>
		<h3>Who are you outside of development?</h3>
		<p>My nose is frequently in a fantasy or murder mystery novel, I've been known to cook a thing or two, I go through yoga and/or biking phases, and music is frequently filling my ears.</p>
		<br/>
		<p>More questions? Drop me a line! <a href="mailto:mary.e.ellis@gmail.com" target="_blank">mary.e.ellis@gmail.com</a></p>
	</div>
</template>

<script>
	export default {
		name: 'Hiring',
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	h1 {
		margin: 40px 0 0;
	}
	h2 {
		margin: 10px 0 0;
	}
	h3 {
		margin: 40px 0 0;
	}
	ul {
		list-style-type: none;
		padding: 0;
	}
	li {
		display: inline-block;
		margin: 0 10px;
	}
</style>
